import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=e8a33230&"
import script from "./NavigationMenu.vue?vue&type=script&lang=ts&"
export * from "./NavigationMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports